module.exports = __webpack_public_path__ + "img/daftar-dokumen.dc48a15b.svg";